import React from 'react';
import AudienceResume from './info/AudienceResume';
import AudienceJudges from './scheduling/AudienceJudges';
import SchedulingActions from './scheduling/SchedulingActions';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { APROBADA, AGENDADA } from '../../../data/audienceStates';
import AudienceOperator from './scheduling/AudienceOperator';
import AudienceActualJudges from './scheduling/AudienceActualJudges';
import AudienceSession from './scheduling/AudienceSession';
//Función principal
const AudienceScheduling = () => {
    //Accedo al store
    const audience = useSelector(state => state.audiences.audienceWork);
    //Renderizo
    return (
        <div className="row">
            {
                audience ? (
                    <React.Fragment>
                        <AudienceResume
                            audience={audience}
                        />

                        {
                            audience.estado.id == AGENDADA && audience.enviarEnlace ? (
                                <AudienceSession
                                    audience={audience}
                                />
                            ) : null
                        }

                        {
                            audience.estado.id == AGENDADA ? (
                                <AudienceOperator
                                    audience={audience}
                                />
                            ) : null
                        }

                        {
                            audience.judges && audience.judges.length > 0 ? (
                                <AudienceJudges
                                    audience={audience}
                                />
                            ) : null
                        }

                        {
                            audience.audienciaJuezList && audience.audienciaJuezList.length > 0 ? (
                                <AudienceActualJudges
                                    audience={audience}
                                />
                            ) : null
                        }
                        
                        {
                            audience.estado.id === APROBADA ? (
                                <SchedulingActions
                                    audience={audience}
                                />
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }
        </div>
    );
};

export default AudienceScheduling;